import React from 'react'
import { useTranslation } from 'react-i18next'

import DateFormats from '../../../../App/Helpers/DateFormats'
import { IWaitingCustomer } from '../../interface/IWaitingCustomer'
import { Card } from '../Card/Card'

type Props = {
  waitingCustomer: IWaitingCustomer
}

const WaitingListCard = ({ waitingCustomer }: Props) => {
  const { t } = useTranslation()

  let calendarUrl = `/calendar`
  if (waitingCustomer.wantedAt) {
    calendarUrl += `/${waitingCustomer.wantedAt.format(
      DateFormats.DATE_FORMAT_API,
    )}`
  }
  calendarUrl += `?customer_id=${waitingCustomer.customer.id}&waiting_customer_id=${waitingCustomer.id}`

  return (
    <Card
      title={waitingCustomer.customer.fullName}
      description={
        waitingCustomer.wantedAt
          ? waitingCustomer.wantedAt.format(DateFormats.DATETIME_FORMAT_FULL)
          : t('No time has been selected')
      }
      text={waitingCustomer.remark}
      waitingCustomer={waitingCustomer}
    />
  )
}

export default WaitingListCard
